import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-personnel-form',
  templateUrl: './personnel-form.component.html',
  styleUrls: ['./personnel-form.component.css'],
})
export class PersonnelFormComponent {
  url: string = 'accountings';
  //urlTwo: string = 'quickbooks';
  urlThree: string = 'services/listCommission';
  id!: string;
  idAccounting!: string;
  form!: FormGroup;
  form_two!: FormGroup;
  roles: Array<any> = [];
  frequencies: Array<any> = [];
  imgModal: string;
  showModalImg = false;
  imgUser: string;
  apiUrl = environment.apiUrl;
  update = true;
  fullname = '';
  step = 1;
  //categories: any[] = [];
  //paymentAccounts: any[] = [];
  isLoading: boolean = false;
  //qboExpenseId!: string;
  //qboSyncToken!: string;
  amount = '';

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Quick Books',
      route: '/numbers/accounting',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Tax compliance',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Invoices',
      route: '/numbers/accounting/invoices',
    },
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      business_name: [''],
      username: ['', [Validators.required]],
      title: [''],
      img: [''],
      type: ['internal', [Validators.required]],
      description: [''],
      dueDate: ['', [Validators.required]],
      value: ['', [Validators.required]],
      frequency: ['', [Validators.required]],
      comments: [''],
      user: ['', [Validators.required]],
      /* vendorId: ['', Validators.required], // VendorRef
      txnDate: ['', Validators.required], // Fecha del gasto
      lines: this.fb.array([], [Validators.required]),
      paymentType: ['Cash', Validators.required],
      paymentAccountId: ['', Validators.required], */
    });

    /* this.form_two = this.fb.group({
      comments: [''],
    }); */
  }

  ngOnInit(): void {
    //this.getCategories();
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        this.getData();
        this.update = false;
      }
    });
    this.frequencies = [
      { code: 1, name: 'WEEKLY' },
      { code: 2, name: 'BIWEEKLY' },
      { code: 3, name: 'YEARLY' },
    ];

    const currentPath = this.router.url.split('/')[2];
    console.log('path:', currentPath);

    if (currentPath === 'freelancers') {
      this.step = 2;
    } else if (currentPath === 'drivers') {
      this.step = 3;
    } else if (currentPath === 'customers') {
      this.step = 4;
    } else {
      this.step = 1;
    }
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.idAccounting) {
      console.log('se va upd');
      this.updateData();
    } else {
      console.log('se va crea');
      this.createData();
    }
    //this.createData();
  }

  getData(): void {
    this.isLoading = true;
    this.dataService
      .getData(`${this.url}/user/${this.id}`)
      .subscribe((response) => {
        console.log('get data ', response);
        this.form.patchValue({
          firstname: response.user.firstname,
          lastname: response.user.lastname,
          business_name: response.user.business_name ?? null,
          username: response.user.username,
          title: response.user?.title,
          img: response.user?.img,
          description: response.data?.description,
          dueDate: response.data?.dueDate,
          value: response.total.toString(),
          frequency: response.data?.frequency,
          comments: response.data?.comments,
          user: this.id,
          //vendorId: response?.user.qboVendorId,
          //txnDate: response?.data?.TxnDate,
          //txnDate: new Date().toISOString().split('T')[0],
          //paymentAccountId: response?.data?.AccountRef?.value,
        });
        this.imgUser = response.user.img
          ? `${this.apiUrl}/uploads/${response.user.img}`
          : './assets/img/faces/marc.jpg';

        this.fullname = response.user.firstname + ' ' + response.user.lastname;

        this.amount = response.total.toString();
        //console.log('amount', this.amount);
        /* this.form_two.patchValue({
        comments: response.comments,
      }); */

        this.idAccounting = response.data?._id;

        //quickbooks
        /* const linesArray = this.form.get('lines') as FormArray;
        while (linesArray.length) {
          linesArray.removeAt(0);
        } */
        //lineItemsArray.clear();

        /* if (response.data) {
          (this.qboExpenseId = response?.data?.Id),
            (this.qboSyncToken = response?.data?.SyncToken),
            (response?.data?.Line || []).forEach((line: any) => {
              const linesGroup = this.fb.group({
                id: line.Id,
                accountId:
                  line.AccountBasedExpenseLineDetail?.AccountRef?.value || '',
                accountName:
                  line.AccountBasedExpenseLineDetail?.AccountRef?.name || '',
                description: line.Description || '', // QuickBooks tiene un campo Description opcional
                amount: line.Amount || 0,
              });
              linesArray.push(linesGroup);
            });
        }  */
        this.isLoading = false;
      });
  }

  /* pru() {
    console.log('form ', this.form.value);
  } */

  createData(): void {
    const formData = {
      ...this.form.value,
    };

    console.log('form', this.form.value);

    this.dataService
      .postData(`${this.url}/add`, formData)
      .subscribe((response) => {
        console.log('response add', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting');
          //this.router.navigateByUrl('/numbers/accounting');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .putData(`${this.url}/edit/${this.idAccounting}`, formData)
      .subscribe((response) => {
        if (response.rst) {
          console.log('response upd', response);
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          //this.router.navigateByUrl('/numbers/accounting');
          this.router.navigateByUrl('/numbers/accounting');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  /* createData(): void {
    this.isLoading = true;
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.urlTwo}/createExpense`, formData)
      .subscribe((response) => {
        console.log('response add createPayment', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.isLoading = false;
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting');
           //this.clearValidator();
             // if (this.internal) {
             //   this.router.navigateByUrl('/numbers/accounting/internal');
             // } else {
             //   this.router.navigateByUrl('/numbers/accounting/external');
             // } 
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }
 
  updateData(): void {
    this.isLoading = true;
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .putData(
        `${this.urlTwo}/editExpense/${this.qboExpenseId}/${this.qboSyncToken}`,
        formData
      )
      .subscribe((response) => {
        console.log('response upd editPayment', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.isLoading = false;
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting');

           //this.clearValidator();
             // if (this.internal) {
             //   this.router.navigateByUrl('/numbers/accounting/internal');
             // } else {
             //   this.router.navigateByUrl('/numbers/accounting/external');
             // } 
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }*/

  openEmail(email: string) {
    if (!email) return;

    const subject = encodeURIComponent('Contacto desde sistema');
    const body = encodeURIComponent(
      'Hola,\n\nMe comunico contigo desde el sistema.\n\nSaludos.'
    );
    //const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;

    const chooserUrl = `https://accounts.google.com/AccountChooser?continue=${encodeURIComponent(
      gmailComposeUrl
    )}`;

    window.open(chooserUrl, '_blank');
  }

  get userImgUrl(): string {
    const img = this.form.get('img')?.value;

    return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';
  }

  openModalImg(img: string) {
    console.log('img', img);
    this.showModalImg = true;

    if (img == 'imgUser') {
      this.imgModal = this.imgUser;
      console.log('imgUser en modal', this.imgUser);
    }
  }

  closeModalImg() {
    this.showModalImg = false;
    this.imgModal = '';
  }

  enableUpdate() {
    this.update = !this.update;
  }

  /* get lines(): FormArray {
    return this.form.get('lines') as FormArray;
  }

  addLine() {
    this.lines.push(
      this.fb.group({
        accountId: ['', Validators.required], // AccountRef.value
        //accountId: [this.categories?.[0]?.Id, Validators.required],
        accountName: [''], // AccountRef.name
        //accountName: [this.categories?.[0]?.Name],
        description: ['Payroll'], // Line.Description
        amount: ['', Validators.required],
      })
    );
  }

  removeLine(index: number) {
    this.lines.removeAt(index);
  } */

  /* setItem(index: number, id: string) {
    const item = this.categories.find((res) => res.Id === id);
    if (!item) return;
    console.log('item', item);

    const lineGroup = this.lines.at(index) as FormGroup;

    lineGroup.patchValue({
      accountId: item.Id,
    });

    console.log('form', this.form.value);
  } */

  /* getCategories() {
    this.isLoading = true;
    this.dataService
      .getData(`${this.urlTwo}/categories`)
      .subscribe((response) => {
        console.log('categories', response);
        const allAccounts = response.data.QueryResponse.Account;

        // Filtrar cuentas de pago
        this.paymentAccounts = allAccounts.filter((acc) =>
          ['Bank', 'Cash', 'CreditCard'].includes(acc.AccountType)
        );

        console.log('paymentAccounts', this.paymentAccounts);
        // Filtrar categorías de gasto activas, excluyendo "Cost of Labor"
        const activeAccounts = allAccounts.filter(
          (acc) => acc.Active !== false
        );

        //this.categories = activeAccounts;
        this.categories = activeAccounts.filter(
          (acc) =>
            acc.AccountType?.toLowerCase() === 'expense' &&
            acc.Name?.toLowerCase() === 'payroll expenses'.toLowerCase()
        );

        console.log('categories', this.categories);
        console.log('this.paymentAccounts[0].Id,', this.paymentAccounts[0].Id);
        console.log('this.categories[0].Id,', this.categories[0].Id);
        this.form.patchValue({
          paymentAccountId: this.paymentAccounts[0].Id,
        });

        this.lines.push(
          this.fb.group({
            accountId: [this.categories?.[0]?.Id || '', Validators.required],
            accountName: [this.categories?.[0]?.Name || ''],
            description: ['Payroll'],
            amount: [this.amount],
          })
        );

        this.isLoading = false;
      });
  } */
}
